import { useState } from 'react';

export default function RadioLogo() {
  const [showPlayer, setShowPlayer] = useState(false);
  const [playerType, setPlayerType] = useState<'ssl' | 'tunein'>('ssl');

  return (
    <div className="bg-gradient-to-br from-purple-800/50 to-blue-800/50 backdrop-blur-sm rounded-3xl p-6 shadow-2xl border border-white/10">
      <div className="text-center">
        <div className="mb-4 flex justify-center">
          <div className="w-32 h-32 bg-gradient-to-br from-yellow-400 via-pink-500 to-red-500 rounded-full flex items-center justify-center shadow-2xl transform hover:scale-105 transition-transform duration-300">
            <div className="w-28 h-28 bg-gray-900 rounded-full flex items-center justify-center">
              <div className="text-center">
                <i className="ri-radio-2-fill text-4xl text-white mb-1"></i>
                <div className="text-white font-bold text-lg">2050</div>
              </div>
            </div>
          </div>
        </div>
        <h2 className="text-3xl font-bold mb-2 bg-gradient-to-r from-yellow-400 via-pink-500 to-red-500 bg-clip-text text-transparent">
          RADIO 2050
        </h2>
        <p className="text-xl text-white font-semibold mb-3">ESPAÑA</p>
        <p className="text-gray-300 text-base mb-4">
          Tu emisora de música adulta contemporánea
        </p>
        
        {!showPlayer ? (
          <div className="flex flex-col gap-3 items-center">
            <button 
              onClick={() => {
                setPlayerType('ssl');
                setShowPlayer(true);
              }}
              className="px-5 py-2 bg-gradient-to-r from-pink-500 to-red-500 text-white rounded-full font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer flex items-center gap-2 text-sm"
            >
              <i className="ri-play-circle-fill text-lg"></i>
              Escuchar en Vivo
            </button>
            <button 
              onClick={() => {
                setPlayerType('tunein');
                setShowPlayer(true);
              }}
              className="px-5 py-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-full font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer flex items-center gap-2 text-sm"
            >
              <i className="ri-radio-line text-lg"></i>
              Escuchar en TuneIn
            </button>
          </div>
        ) : (
          <div className="mt-4">
            <div className="flex justify-center gap-2 mb-3">
              <button
                onClick={() => setPlayerType('ssl')}
                className={`px-4 py-1 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  playerType === 'ssl'
                    ? 'bg-gradient-to-r from-pink-500 to-red-500 text-white'
                    : 'bg-white/20 text-white hover:bg-white/30'
                }`}
              >
                Reproductor SSL
              </button>
              <button
                onClick={() => setPlayerType('tunein')}
                className={`px-4 py-1 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  playerType === 'tunein'
                    ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white'
                    : 'bg-white/20 text-white hover:bg-white/30'
                }`}
              >
                TuneIn Radio
              </button>
            </div>
            
            {playerType === 'ssl' ? (
              <iframe 
                src="https://srv7031.dns-lcinternet.com/cp/widgets/player/single/?p=8018" 
                height="110" 
                width="100%" 
                scrolling="no" 
                style={{ border: 'none', borderRadius: '12px' }}
                title="Radio 2050 España - Reproductor SSL"
              />
            ) : (
              <iframe 
                src="https://tunein.com/embed/player/s260889/" 
                style={{ width: '100%', height: '100px', border: 'none', borderRadius: '12px' }} 
                scrolling="no"
                title="Radio 2050 España - TuneIn Radio"
              />
            )}
            
            <button
              onClick={() => setShowPlayer(false)}
              className="mt-3 px-4 py-2 bg-white/20 text-white rounded-full text-sm font-semibold hover:bg-white/30 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-close-line mr-1"></i>
              Cerrar Reproductor
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
